import { render, staticRenderFns } from "./ReportsManagementReport.vue?vue&type=template&id=c21966a2&scoped=true&"
import script from "./ReportsManagementReport.vue?vue&type=script&lang=js&"
export * from "./ReportsManagementReport.vue?vue&type=script&lang=js&"
import style0 from "./ReportsManagementReport.vue?vue&type=style&index=0&id=c21966a2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21966a2",
  null
  
)

export default component.exports